import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import Page from '../Page';

export const AuthRootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    minHeight: '100vh'
  }
}));

export const AuthSectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 4),
  padding: theme.spacing(5),
  backgroundColor: theme.palette.jobscroll.light,
  border: '1px solid #232935',
  borderRadius: 20,
  [theme.breakpoints.up('md')]: {
    minHeight: 'calc(100vh - 32px)'
  }
}));

export const AuthContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 0)
  }
}));
